import DataSetRowIdentity from '../../../services/dataset-row-identity';
import template from './mx-grid-render.component.html';

MxGridRenderCtrl.$inject = [
	'$scope',
	'uiGridConstants',
	'$templateCache',
	'$timeout',
	'$element',
	'$mdUtil',
	'gridUtil',
	'mx.internationalization',
	'mx.shell.Config',
	'mx.app.DeviceService',
	'$mdConstant',
	'mx.sb.Agent.DataQuery.Enums',
	'mx.app.ColorService',
	'mx.components.MxGridHelper',
];
export function MxGridRenderCtrl(
	$scope,
	uiGridConstants,
	$templateCache,
	$timeout,
	$element,
	$mdUtil,
	gritUtil,
	i18n,
	mxConfig,
	deviceService,
	$mdConstant,
	DataQueryEnums,
	colorService,
	gridHelper
) {
	var vm = this,
		previousClickedRowIndex = -1,
		templates = loadTemplates(),
		isVisibleWatcher,
		contrastColorCache = {};

	//TODO: move it from mx-grid
	mx.components.loadUiGridTemplates($templateCache);
	vm.currencyConfig = mxConfig.get('currency');

	vm.options = {
		rowEquality: DataSetRowIdentity.equal,
		allowPaging: false, //disable internal paging in ui-grid
		allowSearch: false, //disable internal search in ui-grid
		enableGridMenu: false,
		useExternalSorting: true,
		useExternalPagination: true,
		useExternalFiltering: true,
		hideHeader: true,
		flatEntityAccess: true,

		data: 'vm.items',

		// oprimization ...
		virtualizationThreshold: 50,
		excessRows: 20,
		columnVirtualizationThreshold: 3,
		excessColumns: 3,
		selectionRowHeaderWidth: 30,
		headerRowHeight: 46,
		minRowsToShow: deviceService.screenMobile() ? 5 : 10,
		enablePaginationControls: false,
		enableExpandable: true,
		enableExpandableRowHeader: false,
		enableColumnMenus: false,
		disableExport: true,
		enableHorizontalScrollbar: 1,

		expandableRowTemplate: templates.editForm,

		refreshGridCanvas: refreshGridCanvas,
		onRegisterApi: function (gridApi) {
			vm.gridApi = gridApi;

			if (vm.fullHeight === true || (typeof vm.fullHeight === 'object' && vm.fullHeight !== null)) {
				setFullHeight();
			}

			// this functional can be removed if this PR is approved (or similar) https://github.com/angular-ui/ui-grid/pull/6940
			preventHiddenGridRefresh();

			if (vm.enableDragAndDrop) {
				gridApi.draggableRows.on.rowDropped($scope, function () {
					vm.onReorder();
				});
			}

			gridApi.core.on.columnVisibilityChanged($scope, function (column) {
				vm.onColumnVisibilityChanged({ column: column });
			});

			gridApi.core.on.sortChanged($scope, function (grid, columns) {
				vm.onSortChanged({ columns: columns });
			});

			gridApi.core.on.renderingComplete($scope, () => {
				gridHelper.preventStuckingMovingColumns($scope, $element);
			});

			gridApi.core.on.rowsRendered($scope, function () {
				vm.gridViewport = vm.gridViewport || $element.find('.ui-grid-viewport');
				vm.gridViewport.scrollTop(0);
			});

			gridApi.colResizable.on.columnSizeChanged($scope, function (column, columnWidthShift) {
				var absoluteWidth;
				gridApi.grid.columns.forEach(function (col) {
					if (col.name === column.name) {
						absoluteWidth = col.drawnWidth;
					}
				});
				vm.onColumnSizeChanged({
					column: column,
					columnWidthShift: columnWidthShift,
					absoluteWidth: absoluteWidth,
				});
			});

			gridApi.colMovable.on.columnPositionChanged($scope, function (column, oldPosition, newPosition) {
				vm.onColumnPositionChanged({
					column: column,
					oldPosition: oldPosition,
					newPosition: newPosition,
					columns: gridApi.grid.columns,
				});
			});

			setColumns(vm.columns);
			selectItems(vm.executor.selectedRowsOnPage);
			vm.executor.addSelectionHandler(function (data) {
				$timeout(function () {
					selectItems(data.selectedRowsOnPage);
				});
			});

			if (!vm.watchable) {
				vm.executor.addRowChangeHandler(function (row) {
					$timeout(function () {
						refreshRow(row);
					});
				});
			}

			highlightRows(vm.highlightedRows);

			if (vm.inlineMode) {
				gridApi.edit.on.afterCellEdit($scope, function (item, colDef) {
					vm.inlineEditMode = false;
					vm.onCellChanged({ item: item, colDef: colDef });
				});

				gridApi.edit.on.beginCellEdit($scope, function (/*item, colDef*/) {
					vm.inlineEditMode = true;
				});
			}
		},
	};
	vm.inlineEditMode = false;

	vm.imgHost = mxConfig.get('imgHosts').attachments;

	vm.$onInit = function () {
		var enableFiltering = Boolean(vm.executor.preprocessors.columnSearchPreprocessor);
		var enableSorting = Boolean(vm.executor.preprocessors.sortingPreprocessor);

		angular.extend(vm.options, {
			enableFiltering: enableFiltering,
			useUiGridDraggableRowsHandle: vm.enableDragAndDrop,
			enableSorting: enableSorting,
			rowTemplate: getRowTemplate(),
		});

		if (vm.inlineMode) {
			vm.options.cellEditableCondition = function ($scope) {
				return !vm.grid.disabled && !vm.grid.readOnly && vm.grid.isEntityEditable($scope.row.entity);
			};
		}

		vm.initialized = true;

		if (vm.mxContainerCtrl) {
			vm.mxContainerCtrl.registerChild($scope);
		}
	};

	vm.$onChanges = function (changes) {
		if (changes.rowHeight) {
			vm.options.rowHeight = changes.rowHeight.currentValue;
		}

		if (!vm.gridApi) {
			return;
		}

		if (changes.columns) {
			if ($element.is(':visible')) {
				setColumns(changes.columns.currentValue);
				refreshData();
			} else if (!isVisibleWatcher) {
				isVisibleWatcher = $scope.$watch(
					function () {
						return $element.is(':visible');
					},
					function (isVisible) {
						if (isVisible) {
							setColumns(changes.columns.currentValue);
							refreshData();

							// remove watcher
							isVisibleWatcher();
							isVisibleWatcher = undefined;
						}
					}
				);
			}
		}

		if (changes.highlightedRows) {
			highlightRows(changes.highlightedRows.currentValue);
		}

		if (changes.selectionPickerHeight && vm.fullHeight) {
			if (!isNaN(changes.selectionPickerHeight.currentValue)) {
				setFullHeight();
			}
		}
	};

	// Wait while grid will be visible and then call `handleWindowResize()`
	if (!$element.is(':visible')) {
		var firstVisibilityWatch = $scope.$watch(
			$.debounce(300, function () {
				if ($element.is(':visible')) {
					vm.gridApi.core.handleWindowResize();
					// remove watcher
					firstVisibilityWatch();
					firstVisibilityWatch = undefined;
				}
			})
		);
	}

	//Overrides angular-ui-grids on-mousewheel function, which destroys scrolling when the grid has a certain height
	gritUtil.on.mousewheel = function () {};

	vm.processObject = processObject;
	vm.onInternalItemClick = onInternalItemClick;
	vm.onInternalRightItemClick = onInternalRightItemClick;
	vm.onInternalDblItemClick = onInternalDblItemClick;
	vm.onAllRowsSelectionClick = onAllRowsSelectionClick;
	vm.onRowSelectionClick = onRowSelectionClick;
	vm.onColumnFilterMenuKeyDown = onColumnFilterMenuKeyDown;

	/* Some tricks aka kostyls which should be removed */
	initTricks();

	var clickHandler = $mdUtil.debounce(function (type, row) {
		switch (type) {
			case 'left':
				vm.onItemClick({ item: row.entity });
				break;
			case 'dbl':
				vm.onItemDblClick({ item: row.entity });
				break;
		}
	}, 350);

	return vm;

	function setFullHeight() {
		const isInsidePanel = $($element).closest('.layout_container_mode_panel_inner, mx-side-panel-tab-body').is('.layout_container_mode_panel_inner');
		let layoutBottomOffset = isInsidePanel ? 22 : 0;
		let dialogButtonsOffset = 46;
		const dialogBottomErrorsPlaceholder = $('.mx-side-panel-tab.active-tab mx-form-errors').height() || 0;
		let additionalGap = isInsidePanel ? 30 : 8;
		if (typeof vm.fullHeight === 'object') {
			layoutBottomOffset = typeof vm.fullHeight.layoutBottomOffset === 'number' ? vm.fullHeight.layoutBottomOffset : layoutBottomOffset;
			dialogButtonsOffset = typeof vm.fullHeight.dialogButtonsOffset === 'number' ? vm.fullHeight.dialogButtonsOffset : dialogButtonsOffset;
		}

		let nearestVisibleEl = $element;
		while (!nearestVisibleEl.is(':visible')) {
			nearestVisibleEl = nearestVisibleEl.parent();
		}
		if ($element !== nearestVisibleEl) {
			additionalGap += 30;
		}

		let offset = nearestVisibleEl.offset().top + layoutBottomOffset + additionalGap + dialogBottomErrorsPlaceholder + dialogButtonsOffset;

		// LookUp Dialog MultiSelection case
		if (!isNaN(vm.selectionPickerHeight)) {
			offset += vm.selectionPickerHeight;
		}

		$element.css('min-height', 'calc(100vh - ' + Math.ceil(offset) + 'px)');
		vm.gridApi.grid.gridHeight = $element[0].offsetHeight;
		vm.gridApi.grid.buildStyles();
	}

	function onColumnFilterMenuKeyDown($event) {
		// By default md-menu will be closed if TAB is pressed.
		// Here this TAB-pressed event is stopped in all cases except pressed on ApplyButton.
		// ApplyButton is the last element of filter menu, so after TAB is pressed on it
		// the menu should be closed and keyboard navigation will continue throw other part of the document
		if ($event.which === $mdConstant.KEY_CODE.TAB) {
			if (!$event.target.classList.contains('mx-grid--column-filter-panel-apply')) {
				$event.stopPropagation();
			}
		}

		// Left/Right keys doesn't work for <input/> inside <md-menu-content/>. Let's prevent it
		if ($event.which === $mdConstant.KEY_CODE.LEFT_ARROW || $event.which === $mdConstant.KEY_CODE.RIGHT_ARROW) {
			$event.stopPropagation();
		}
	}

	function onInternalItemClick(event, row) {
		event.stopPropagation();
		highlightRows([row.entity], vm.inlineEditMode);
		clickHandler('left', row);
	}

	function onInternalRightItemClick(event, row) {
		event.stopPropagation();
		highlightRows([row.entity]);
		vm.onItemRightClick({ item: row.entity });
	}

	function onInternalDblItemClick(event, row) {
		event.stopPropagation();
		highlightRows([row.entity], vm.inlineMode);
		clickHandler('dbl', row);
	}

	function refreshGridCanvas() {
		vm.gridApi.grid.redrawInPlace(true);
		$scope.$evalAsync(function () {
			vm.gridApi.grid.refreshCanvas(true);
			vm.gridApi.grid.callDataChangeCallbacks(uiGridConstants.dataChange.ROW);
		});
	}

	function refreshRow(entity) {
		var row = vm.gridApi.grid.rows.filter(function (row) {
			return row.entity === entity;
		})[0];
		if (row) {
			row.setRowInvisible(row);
			$timeout(function () {
				row.clearRowInvisible(row);
			});
		}
	}

	function scrollToItem(item) {
		// fix: we have to reset this property to fix ui-grid's calculations (NGR)
		vm.gridApi.grid.renderContainers.body.prevScrolltopPercentage = undefined;
		// end of fix
		// vm.gridApi.grid.scrollTo(item);
		vm.gridApi.grid.scrollToIfNecessary(item, null);
	}

	function onRowSelectionClick(event, clickedRow) {
		event.stopPropagation();

		if (event.shiftKey && previousClickedRowIndex !== -1) {
			var index = vm.gridApi.grid.rows.indexOf(clickedRow);
			var startIndex = Math.min(index, previousClickedRowIndex);
			var endIndex = Math.max(index, previousClickedRowIndex);
			var isSelect = !clickedRow.isSelected;

			var selectedItems = [];
			vm.gridApi.grid.rows.forEach(function (row, index) {
				if (index < startIndex || index > endIndex) {
					if (row.isSelected) {
						selectedItems.push(row.entity);
					}
				} else {
					if (isSelect) {
						selectedItems.push(row.entity);
					}
				}
			});

			vm.executor.changePageSelection(selectedItems);
		} else {
			vm.executor.toggleRowSelection(clickedRow.entity);
		}

		previousClickedRowIndex = vm.gridApi.grid.rows.indexOf(clickedRow);
	}

	function onAllRowsSelectionClick(event) {
		event.stopPropagation();

		if (vm.allRowsIsSelected) {
			vm.executor.changePageSelection([]);
		} else {
			vm.executor.changePageSelection(vm.executor.dataItems);
		}

		previousClickedRowIndex = -1;
	}

	function isAllRowsSelected() {
		return (
			Boolean(vm.gridApi.grid.rows.length) &&
			vm.gridApi.grid.rows.every(function (row) {
				return row.isSelected;
			})
		);
	}

	function selectItems(selectedItems) {
		if (!Array.isArray(selectedItems)) {
			selectedItems = [];
		}
		vm.gridApi.grid.rows.forEach(function (row) {
			row.isSelected = selectedItems.indexOf(row.entity) >= 0;
		});

		vm.allRowsIsSelected = isAllRowsSelected();
	}

	function highlightRows(items, withoutScrolling) {
		if (!Array.isArray(items)) {
			items = [];
		}

		var highlightedRows = [];

		vm.gridApi.grid.rows.forEach(function (row) {
			if (items.indexOf(row.entity) >= 0) {
				row.isHighlighted = true;
				highlightedRows.push(row);
			} else {
				row.isHighlighted = false;
			}
		});

		if (highlightedRows.length === 1 && !withoutScrolling) {
			scrollToItem(highlightedRows[0]);
		}
	}

	function processObject(data, col) {
		if (!col || typeof data === 'undefined') {
			return data;
		}

		var column = col.colDef.item;

		if (!column || column.IsEnum) {
			return data;
		}

		switch (column.AttributeValueType) {
			case mx.shell.ObjectPropertyType.String.name:
			case mx.shell.ObjectPropertyType.Guid.name:
			case mx.shell.ObjectPropertyType.Text.name:
				return typeof data === 'string' ? mx.components.Utils.htmlEncode(data) : data;

			case mx.shell.ObjectPropertyType.Integer.name:
			case mx.shell.ObjectPropertyType.Float.name:
			case mx.shell.ObjectPropertyType.Long.name:
			case mx.shell.ObjectPropertyType.Decimal.name:
				return col.colDef.item.AttributeValueType && !col.colDef.item.ReferenceTo
					? i18n.formatNumber(data, col.colDef.item.AttributeValueType, col.colDef.item.Format)
					: data;

			case mx.shell.ObjectPropertyType.Currency.name:
				var currencyConfig = vm.currencyConfig;
				return typeof data === 'object'
					? i18n.formatCurrency(
							data,
							undefined,
							currencyConfig && currencyConfig.showCurrencyCode !== true && currencyConfig.showCurrencyCode !== 'true',
							currencyConfig.availableCurrencies
					  )
					: data;
			case mx.shell.ObjectPropertyType.Date.name:
				return typeof data === 'string' ? i18n.formatUTCDate(data, col.colDef.item.Format) : data;
			case mx.shell.ObjectPropertyType.Color.name:
				return typeof data === 'string' ? data.replace(/0xff/i, '#') : data;
			default:
				return data;
		}
	}

	function handleScript(column, row, script) {
		var cacheFieldName = '_' + column.Name + '_scriptResult';
		if (row.entity[cacheFieldName]) {
			return row.entity[cacheFieldName];
		} else {
			try {
				var func = new Function('$item', '$value', script);
				return func(row.entity, row.entity[column.Name + '_Value'] || row.entity[column.Name]);
			} catch (e) {
				var type = column.ImageScript ? ' [Image Script]' : column.ColorScript ? ' [Color Script]' : '';
				console.error('Error in DataQuery column ' + (column.Title || column.Name) + type + ': ' + e.message);
				return null;
			}
		}
	}

	function graphicType(row, col) {
		var path = getGraphicPath(row, col);
		if (!path) {
			return 0;
		}
		if (path.indexOf('/') >= 0) {
			return 1;
		}
		return 2;
	}

	function calcColor(row, item) {
		var clr = null;

		if (item.ColorType) {
			clr = handleScript(item, row, item.ColorScript);
		} else {
			clr = row.entity[item.Name + '_Color'];
		}

		return clr && clr !== null ? clr.trim().toLowerCase().replace('0xff', '#') : null;
	}

	function getGraphicPath(row, col) {
		var item = col.colDef.item;

		var imageString;
		if (item.ImageScript) {
			imageString = handleScript(item, row, item.ImageScript);
		} else {
			imageString = row.entity[item.Name + '_Image'] || row.entity[item.Name];
		}

		return imageString === null || imageString.indexOf('/') >= 0 ? imageString : imageString.trim().replace(/\s+/g, '_');
	}

	function colorToRgba(color, alpha) {
		if (color && color !== null && color.includes('#')) {
			// if (hex) -> rgba
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
			if (result) {
				return 'rgba(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + alpha || '0.5' + ')';
			}
		}

		return color;
	}

	function setColumns() {
		var columns = vm.columns;

		var rowTextData = _.find(columns, ['ColorType', DataQueryEnums.ColorTypeEnum.RowText]);
		var rowBgData = _.find(columns, ['ColorType', DataQueryEnums.ColorTypeEnum.RowBackground]);

		columns = columns.filter(function (clm) {
			return clm.DisplayType !== DataQueryEnums.ColumnDisplayTypeEnum.Hidden; // Exclude Visible None
		});

		if (vm.enableRowSelection) {
			var selectionColumn = {
				Type: 'selectItemCheckbox',
				AttributeValueType: 'selectItemCheckbox',
				Alignment: DataQueryEnums.ColumnAlignmentsEnum.Center,
				Name: 'Sys-selectItemCheckbox',
				Width: 40,
				enableCellEdit: false,
				AriaHidden: true,
			};
			columns = [selectionColumn].concat(columns);
		}

		/*
		TODO: implementation of quickfilter-column is needed
		if (vm.executor.preprocessors.quickFilter) {
			var quicFilterColumn = {
				Type: 'quickfilter',
				AttributeValueType: 'quickfilter',
				Alignment: '1',
				Name: 'Sys-Flags',
				Width: '58px',
				Title: i18n.get('solutionBuilderAgent.common.quickFilter'),
				Labels: vm.quickFilterPreprocessor.titles,
				Parts: vm.quickFilterPreprocessor.parts,
				AriaHidden: true
			};
		}*/

		vm.options.columnDefs = columns.map(function (column) {
			var alignClass =
				'mx-grid-cell-' +
				((column.Alignment === DataQueryEnums.ColumnAlignmentsEnum.Left && 'left') ||
					(column.Alignment === DataQueryEnums.ColumnAlignmentsEnum.Center && 'center') ||
					(column.Alignment === DataQueryEnums.ColumnAlignmentsEnum.Right && 'right'));

			var cellTemplate = _getCellTempate(vm.watchable),
				editableCellTemplate,
				headerTemplate = templates.headerTemplate,
				enableCellEdit = Boolean(column.RawValuePropertyName) && vm.inlineMode;

			switch (column.AttributeValueType) {
				case mx.shell.ObjectPropertyType.Icon.name:
					cellTemplate = templates.iconCell;
					editableCellTemplate = templates.iconEditCell;
					break;
				case mx.shell.ObjectPropertyType.Integer.name:
				case mx.shell.ObjectPropertyType.Float.name:
				case mx.shell.ObjectPropertyType.Long.name:
				case mx.shell.ObjectPropertyType.Decimal.name:
					editableCellTemplate = templates.numberEditCell;
					break;
				case mx.shell.ObjectPropertyType.Currency.name:
					editableCellTemplate = templates.currencyEditCell;
					break;
				case mx.shell.ObjectPropertyType.Date.name:
					editableCellTemplate = templates.dateEditCell;
					break;
				case mx.shell.ObjectPropertyType.Color.name:
					cellTemplate = templates.colorCell;
					editableCellTemplate = templates.colorEditCell;
					break;
				case mx.shell.ObjectPropertyType.Boolean.name:
					enableCellEdit = false;
					cellTemplate = vm.inlineMode ? templates.editedBooleanCell : vm.watchable ? templates.readOnlyBooleanCell : templates.readOnlyBooleanCellOneTime;
					break;
				case 'selectItemCheckbox':
					cellTemplate = templates.selectItemCheckboxCell();
					headerTemplate = templates.selectItemCheckboxHeader();
					break;
				case 'quickfilter':
					cellTemplate = templates.quickFilterCell(column.Labels, column.Parts);
					headerTemplate = templates.quickFilterHeader(column.Labels, column.Parts);
					break;
			}

			if (column.DisplayImage === DataQueryEnums.DisplayImageEnum.Image) {
				cellTemplate = templates.imageCell;
			} else if (column.DisplayImage === DataQueryEnums.DisplayImageEnum.ImageWithText) {
				cellTemplate = templates.imageCell + _getCellTempate();
			}

			if (column.IsEnum) {
				editableCellTemplate = '<mx-grid-select data-col="col" data-row="row"></mx-grid-select>';
			}

			if (column.IsPickup) {
				editableCellTemplate = '<mx-grid-object-picker data-col="col" data-row="row"></mx-grid-object-picker>';
			}

			var field = column.Name;
			var visible = column.IsDisplay && (column.visible === undefined ? column.DisplayType !== DataQueryEnums.ColumnDisplayTypeEnum.InvisibleByDefault : column.visible);

			var mappedColumn = {
				editableCellTemplate: editableCellTemplate,
				field: field,
				item: column,
				rowTextData: rowTextData,
				rowBackgroundData: rowBgData,
				getImage: getGraphicPath,
				graphicType: graphicType,
				getColor: getColor,
				displayName: column.Title,
				visible: visible,
				width: column.Width || '*',
				minWidth: 50,
				formatFn: column.formatFn,
				enableCellEdit: enableCellEdit,
				cellClass: alignClass,
				headerCellClass: alignClass,
				enableSorting: vm.options.enableSorting && column.Sorting !== DataQueryEnums.ColumnSortingEnum.Disabled,
				cellTemplate: cellTemplate,
				headerCellTemplate: headerTemplate,
				cellFilter: column.cellFilter,
				filterHeaderTemplate: templates.columnFilter,
				filter: column.filter,
				groupingIsAvailable: false, //column.groupingIsAvailable, //TODO: grouping is temporary disabled until new grids will be used for search pages
				ariaHidden: column.AriaHidden,
				onGroupingClick: function (event, colDef) {
					vm.onGroupingClick({ event: event, column: colDef.item });
				},
			};

			if (vm.options.enableSorting && (column.Sorting === DataQueryEnums.ColumnSortingEnum.Ascending || column.Sorting === DataQueryEnums.ColumnSortingEnum.Descending)) {
				mappedColumn.sort = {
					direction: column.Sorting === DataQueryEnums.ColumnSortingEnum.Ascending ? uiGridConstants.ASC : uiGridConstants.DESC,
					priority: column.SortingPriority,
				};
			}

			Object.defineProperty(column, 'visible', {
				configurable: true,
				get: function () {
					return visible;
				},
				set: function (newValue) {
					if (newValue !== visible) {
						mappedColumn.visible = newValue && column.IsDisplay;
						vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
						visible = newValue;
					}
				},
			});

			return mappedColumn;
		});
	}

	function getColor(row, col, isText) {
		var colorType = isText ? DataQueryEnums.ColorTypeEnum.CellText : DataQueryEnums.ColorTypeEnum.CellBackground;
		var rowColor = isText ? col.colDef.rowTextData : col.colDef.rowBackgroundData;
		var color = null;

		if (!isText && col.colDef.item.Color) {
			color = col.colDef.item.Color;
		}

		if (!color && col.colDef.item.ColorType === colorType) {
			color = calcColor(row, col.colDef.item);
		}

		if (!color && rowColor) {
			color = calcColor(row, rowColor);
		}

		if (color) {
			var res = {};
			if (color.indexOf(':') > 0) {
				var arr = color.split(':');
				res[arr[0]] = arr[1];
			} else {
				res[isText ? 'color' : 'background-color'] = isText ? color : colorToRgba(color, 0.3);
			}

			if (mx.isEnhancedColorContrastMode && res['color']) {
				contrastColorCache[res['color']] ||= colorService.enhanceColorContrast(res['color'], undefined, 3);
				res['color'] = contrastColorCache[res['color']];
			}

			return res;
		}

		return null;
	}

	function refreshData() {
		var prevGridData = vm.items;
		vm.items = [];
		$timeout(function () {
			vm.items = prevGridData;
		}, 1);
	}

	/* Some tricks aka kostyls which should be removed */
	function initTricks() {
		// Trick which fixes sets of width/height to 0 for mx-grids which are hidden on UI
		$scope.$watch('vm.gridApi.grid.gridWidth', function (newVal, oldVal) {
			if (newVal === 0 && oldVal !== 0 && typeof oldVal === 'number') {
				vm.gridApi.grid.gridWidth = oldVal;
			}
		});
		$scope.$watch('vm.gridApi.grid.gridHeight', function (newVal, oldVal) {
			if (newVal === 0 && oldVal !== 0 && typeof oldVal === 'number') {
				vm.gridApi.grid.gridHeight = oldVal;
			}
		});
		// Fixes bug when grid is not visible but should be rendered.
		// In this case we will wait until it's visible.
		/*var _isReadyForRendering = $scope.$watch(function() {return $element.is(':visible');}, function (isVisible) {
			if (isVisible) {
				vm._isReadyForRendering = true;
				_isReadyForRendering();
			}
		});*/

		window.onbeforeprint = function () {
			$scope.$evalAsync(function () {
				vm.options.minRowsToShow = vm.executor.dataItems.length;
				vm.options.virtualizationThreshold = vm.options.minRowsToShow;
				$element.find('.grid').css({ height: 60 + vm.options.minRowsToShow * vm.rowHeight + 'px' });
				$element.find('.ui-grid-viewport').css({
					height: 60 + vm.options.minRowsToShow * vm.rowHeight + 'px',
					overflow: 'visible',
				});
				$element.find('.ui-grid').css('position', 'static');
			});
		};
		window.onafterprint = function () {
			$scope.$evalAsync(function () {
				vm.options.minRowsToShow = deviceService.screenMobile() ? 5 : 10;
				vm.options.virtualizationThreshold = vm.options.minRowsToShow;
				$element.find('.ui-grid-viewport').css({
					height: '',
					position: 'absolute',
				});
			});
		};
	}

	function loadTemplates() {
		return {
			// pager: $templateCache.get('mx-grid/mx-grid-pager.html'),

			headerTemplate: $templateCache.get('mx-grid/mx-grid-header-cell.html'),
			columnFilter: $templateCache.get('mx-grid/mx-grid-column-filters/mx-grid-column-filter.html'),

			editedBooleanCell:
				' <div ng-disabled="false" ><mx-checkbox ng-model="row.entity[col.field]" aria-disabled="true" aria-label="boolfield"  class="mx-grid-checkbox"></mx-checkbox></div>',

			quickFilterCell: function (labels, parts) {
				return (
					' <mx-quick-filter static-mode="true" value="{{:: row.entity[col.field]}}" titles="' +
					JSON.stringify(labels).replace(/"/g, '&#34;') +
					'"  parts="' +
					parts +
					'"></mx-quick-filter>'
				);
			},

			quickFilterHeader: function (labels, parts) {
				return ' <mx-quick-filter value="0" titles="' + JSON.stringify(labels).replace(/"/g, '&#34;') + '"  parts="' + parts + '"></mx-quick-filter>';
			},

			iconCell:
				'<div title="{{row.entity[col.field]}}" class="mx-grid-icon-picker-static"><md-icon class="mx-grid-icon" >{{row.entity[col.field]}}</md-icon><span> {{row.entity[col.field]}}</span></div>',
			numberEditCell: '<mx-grid-numeric-edit  data-col="col" data-row="row"></mx-grid-numeric-edit>',
			iconEditCell: '<mx-grid-icon-picker data-col="col" data-row="row"></mx-grid-icon-picker>',
			colorCell:
				'<div class="mx-grid-color-picker-static">' +
				'<div class="color-box" ng-style="row.entity[col.field] && {\'background-color\': grid.appScope.vm.processObject(COL_FIELD, col, row)}">&nbsp;</div>' +
				'<div class="color-value">{{ grid.appScope.vm.processObject(COL_FIELD, col, row) }}' +
				'</div>',

			imageCell:
				'<div ng-switch=":: col.colDef.graphicType(row,col)">' +
				'<img ng-switch-when="1" ng-src="{{grid.appScope.vm.imgHost + col.colDef.getImage(row,col)}}" title="{{row.entity[col.field]}}">' +
				'<div ng-switch-when="2" title="{{row.entity[col.field]}}"><md-icon class="mx-grid-icon" ng-style="col.colDef.getColor(row,col, true)">{{col.colDef.getImage(row,col)}}</md-icon></div>' +
				'</div>',

			colorEditCell: '<mx-grid-color-picker data-col="col" data-row="row"></mx-grid-color-picker>',

			currencyEditCell: '<mx-grid-currency data-col="col" data-row="row"></mx-grid-currency>',
			dateEditCell: '<mx-grid-date-time-picker data-col="col" data-row="row"></mx-grid-date-time-picker>',

			selectItemCheckboxHeader: function () {
				return '<md-checkbox class="mx-grid-checkbox" ng-checked="grid.appScope.vm.allRowsIsSelected" ng-disabled="grid.appScope.vm.grid.readOnly || grid.appScope.vm.grid.disabled" aria-hidden="true" role="none" ng-click="grid.appScope.vm.onAllRowsSelectionClick($event)"></md-checkbox>';
			},
			selectItemCheckboxCell: function () {
				return '<md-checkbox class="mx-grid-checkbox" ng-checked="row.isSelected" ng-disabled="grid.appScope.vm.grid.readOnly || grid.appScope.vm.grid.disabled" aria-hidden="true" role="none" ng-click="grid.appScope.vm.onRowSelectionClick($event, row)"></md-checkbox>';
			},

			readOnlyBooleanCellOneTime:
				' <md-icon class="mx-grid-icon" ng-style="col.colDef.getColor(row,col, true)"> {{ ::MODEL_COL_FIELD?"check_box":"check_box_outline_blank"}}</md-icon>',
			readOnlyBooleanCell:
				' <md-icon class="mx-grid-icon" ng-style="col.colDef.getColor(row,col, true)"> {{ MODEL_COL_FIELD?"check_box":"check_box_outline_blank"}}</md-icon>',

			actionRow:
				'<div layout="row" class="mx-grid-cell-row-actions">' +
				'<md-button ng-if=":: grid.appScope.hasEdit" aria-label="Edit" ng-click="grid.appScope.onEdit({entity: row.entity})" ><md-icon class="mx-grid-icon" aria-label="Edit" >edit</md-icon></md-button>' +
				'</div>',

			editForm: '<mx-grid-edit-form row="row" inline-form-fields = "vm.options.inlineFormFields"> </mx-grid-edit-form>',
		};
	}

	function getRowTemplate() {
		return `<div
				ng-dblclick="grid.appScope.rowDblClick(row)"
				${
					vm.enableDragAndDrop
						? 'grid="grid" ui-grid-draggable-row class="mx-grid-row-cells-wrapper ui-grid-draggable-row-handle" draggable="true" '
						: ' class="mx-grid-row-cells-wrapper" '
				}
			>
			<div
				ng-style=":: col.colDef.getColor(row,col, false)"
				ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"
				class="ui-grid-cell"
				ng-class=":: { 'ui-grid-row-header-cell': !!col.isRowHeader}"
				role="{{:: col.colDef.ariaHidden ? 'presentation' : 'gridcell' }}"
				ui-grid-cell
			></div>
		</div>`;
	}

	function _getCellTempate(isTextWatchable) {
		// "::" One-time binding is used because of MX-GRID performance issues.
		// if you need to refresh data dynamically - try to invent more smart way to do it instead of just removing "::"!
		// For exaple: make some additional parameter for grid ("watchible/not wachible"), or upadate it by some special events "onGridItemUpdate ..."
		// (Talk to Nick M.)
		return (
			'<div class="ui-grid-cell-contents" title="TOOLTIP" ng-bind-html="' +
			(isTextWatchable ? '' : '::') +
			' grid.appScope.vm.processObject(COL_FIELD, col, row) CUSTOM_FILTERS" ng-style=":: col.colDef.getColor(row,col, true)"></div>'
		);
	}

	function preventHiddenGridRefresh() {
		var allResizeEvents = $._data(window, 'events').resize || [];
		var last = allResizeEvents.length - 1;
		var uiGridResizeHandler = allResizeEvents[last].handler;
		if (uiGridResizeHandler.toString().indexOf('.gridWidth') > 0) {
			allResizeEvents[last].handler = function _mxGridResize() {
				if ($element.is(':visible')) {
					uiGridResizeHandler();
				}
			};

			$element.on('$destroy', function () {
				$(window).off('resize', uiGridResizeHandler);
			});
		}
	}
}

export default {
	bindings: {
		columns: '<',
		grid: '<',
		executor: '<',
		items: '<',

		enableRowSelection: '<',
		selectionPickerHeight: '<',

		enableDragAndDrop: '<',
		inlineMode: '<',
		highlightedRows: '<',
		rowHeight: '<',
		rowColoringEnabled: '<',
		watchable: '<',
		fullHeight: '<',

		onItemClick: '&',
		onItemDblClick: '&',
		onItemRightClick: '&',

		onGroupingClick: '&',

		onColumnVisibilityChanged: '&',
		onSortChanged: '&',
		onColumnPositionChanged: '&',
		onColumnSizeChanged: '&',
		onReorder: '&',

		onCellChanged: '&',
	},
	require: {
		mxContainerCtrl: '?^^mxContainer',
	},
	controller: MxGridRenderCtrl,
	controllerAs: 'vm',
	template: template,
};
